// src/styles/articleClasses.js
export const photoCreditClass = "text-xs font-extralight italic mb-4";
export const bulletPointClass = "w-7 h-7 text-yellow-400 mr-4"; // Add padding for space